module.exports = __webpack_public_path__ + "img/mintable_custom.be1f72d4.png";